import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=be7babb8&scoped=true&lang=pug"
import script from "./ScrollContainer.vue?vue&type=script&lang=ts"
export * from "./ScrollContainer.vue?vue&type=script&lang=ts"
import style0 from "./ScrollContainer.vue?vue&type=style&index=0&id=be7babb8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7babb8",
  null
  
)

export default component.exports